import { render, staticRenderFns } from "./EditOrderPrice.vue?vue&type=template&id=6fed8b47&scoped=true"
import script from "./EditOrderPrice.vue?vue&type=script&lang=js"
export * from "./EditOrderPrice.vue?vue&type=script&lang=js"
import style0 from "./EditOrderPrice.vue?vue&type=style&index=0&id=6fed8b47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed8b47",
  null
  
)

export default component.exports